import * as s from "react";
import { u as xe, o as Ae, s as ye, f as ve, a as Ce, b as be, h as Se, l as Oe, c as Re } from "./floating-ui.react-dom-JfyihLpw.js";
import { P as E } from "./index-BrTLHETv.js";
import { jsx as p } from "react/jsx-runtime";
import { u as z } from "./index-DLcqcWxM.js";
import { c as Ne } from "./index-UFb2E87s.js";
import { u as Ee } from "./index-DwYXX2sM.js";
import { u as j } from "./index-DuekHEmj.js";
import { u as $e } from "./index-CHDs-SiB.js";
var _e = "Arrow", Z = s.forwardRef((e, a) => {
  const { children: o, width: t = 10, height: n = 5, ...r } = e;
  return /* @__PURE__ */ p(
    E.svg,
    {
      ...r,
      ref: a,
      width: t,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? o : /* @__PURE__ */ p("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Z.displayName = _e;
var He = Z, $ = "Popper", [L, Ue] = Ne($), [We, U] = L($), q = (e) => {
  const { __scopePopper: a, children: o } = e, [t, n] = s.useState(null);
  return /* @__PURE__ */ p(We, { scope: a, anchor: t, onAnchorChange: n, children: o });
};
q.displayName = $;
var G = "PopperAnchor", J = s.forwardRef(
  (e, a) => {
    const { __scopePopper: o, virtualRef: t, ...n } = e, r = U(G, o), i = s.useRef(null), w = z(a, i);
    return s.useEffect(() => {
      r.onAnchorChange((t == null ? void 0 : t.current) || i.current);
    }), t ? null : /* @__PURE__ */ p(E.div, { ...n, ref: w });
  }
);
J.displayName = G;
var _ = "PopperContent", [Ie, Me] = L(_), K = s.forwardRef(
  (e, a) => {
    var Y, X, B, D, F, k;
    const {
      __scopePopper: o,
      side: t = "bottom",
      sideOffset: n = 0,
      align: r = "center",
      alignOffset: i = 0,
      arrowPadding: w = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: P = 0,
      sticky: h = "partial",
      hideWhenDetached: A = !1,
      updatePositionStrategy: y = "optimized",
      onPlaced: f,
      ...l
    } = e, v = U(_, o), [m, C] = s.useState(null), te = z(a, (x) => C(x)), [N, re] = s.useState(null), g = $e(N), oe = (g == null ? void 0 : g.width) ?? 0, H = (g == null ? void 0 : g.height) ?? 0, ne = t + (r !== "center" ? "-" + r : ""), ae = typeof P == "number" ? P : { top: 0, right: 0, bottom: 0, left: 0, ...P }, W = Array.isArray(d) ? d : [d], ie = W.length > 0, b = {
      padding: ae,
      boundary: W.filter(Xe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: ie
    }, { refs: se, floatingStyles: I, placement: pe, isPositioned: S, middlewareData: u } = xe({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: ne,
      whileElementsMounted: (...x) => Re(...x, {
        animationFrame: y === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Ae({ mainAxis: n + H, alignmentAxis: i }),
        c && ye({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? Oe() : void 0,
          ...b
        }),
        c && ve({ ...b }),
        Ce({
          ...b,
          apply: ({ elements: x, rects: T, availableWidth: ge, availableHeight: ue }) => {
            const { width: we, height: Pe } = T.reference, R = x.floating.style;
            R.setProperty("--radix-popper-available-width", `${ge}px`), R.setProperty("--radix-popper-available-height", `${ue}px`), R.setProperty("--radix-popper-anchor-width", `${we}px`), R.setProperty("--radix-popper-anchor-height", `${Pe}px`);
          }
        }),
        N && be({ element: N, padding: w }),
        Be({ arrowWidth: oe, arrowHeight: H }),
        A && Se({ strategy: "referenceHidden", ...b })
      ]
    }), [M, ce] = ee(pe), O = Ee(f);
    j(() => {
      S && (O == null || O());
    }, [S, O]);
    const de = (Y = u.arrow) == null ? void 0 : Y.x, le = (X = u.arrow) == null ? void 0 : X.y, fe = ((B = u.arrow) == null ? void 0 : B.centerOffset) !== 0, [he, me] = s.useState();
    return j(() => {
      m && me(window.getComputedStyle(m).zIndex);
    }, [m]), /* @__PURE__ */ p(
      "div",
      {
        ref: se.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...I,
          transform: S ? I.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: he,
          "--radix-popper-transform-origin": [
            (D = u.transformOrigin) == null ? void 0 : D.x,
            (F = u.transformOrigin) == null ? void 0 : F.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((k = u.hide) == null ? void 0 : k.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p(
          Ie,
          {
            scope: o,
            placedSide: M,
            onArrowChange: re,
            arrowX: de,
            arrowY: le,
            shouldHideArrow: fe,
            children: /* @__PURE__ */ p(
              E.div,
              {
                "data-side": M,
                "data-align": ce,
                ...l,
                ref: te,
                style: {
                  ...l.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: S ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
K.displayName = _;
var Q = "PopperArrow", Ye = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, V = s.forwardRef(function(a, o) {
  const { __scopePopper: t, ...n } = a, r = Me(Q, t), i = Ye[r.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p(
      "span",
      {
        ref: r.onArrowChange,
        style: {
          position: "absolute",
          left: r.arrowX,
          top: r.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[r.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[r.placedSide],
          visibility: r.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p(
          He,
          {
            ...n,
            ref: o,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
V.displayName = Q;
function Xe(e) {
  return e !== null;
}
var Be = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(a) {
    var v, m, C;
    const { placement: o, rects: t, middlewareData: n } = a, i = ((v = n.arrow) == null ? void 0 : v.centerOffset) !== 0, w = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [d, P] = ee(o), h = { start: "0%", center: "50%", end: "100%" }[P], A = (((m = n.arrow) == null ? void 0 : m.x) ?? 0) + w / 2, y = (((C = n.arrow) == null ? void 0 : C.y) ?? 0) + c / 2;
    let f = "", l = "";
    return d === "bottom" ? (f = i ? h : `${A}px`, l = `${-c}px`) : d === "top" ? (f = i ? h : `${A}px`, l = `${t.floating.height + c}px`) : d === "right" ? (f = `${-c}px`, l = i ? h : `${y}px`) : d === "left" && (f = `${t.floating.width + c}px`, l = i ? h : `${y}px`), { data: { x: f, y: l } };
  }
});
function ee(e) {
  const [a, o = "center"] = e.split("-");
  return [a, o];
}
var qe = q, Ge = J, Je = K, Ke = V;
export {
  Ge as A,
  Je as C,
  qe as R,
  Ke as a,
  Ue as c
};
//# sourceMappingURL=index-Duz4GUys.js.map
